import { render, staticRenderFns } from "./CardStatsV3.vue?vue&type=template&id=5007006f&scoped=true&"
import script from "./CardStatsV3.vue?vue&type=script&lang=js&"
export * from "./CardStatsV3.vue?vue&type=script&lang=js&"
import style0 from "./CardStatsV3.vue?vue&type=style&index=0&id=5007006f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5007006f",
  null
  
)

export default component.exports